const COMPONENTS_DOMAIN = 'components'
const COMPONENTS_STATE = {
  data: {}
}

const COMPONENTS_ACTION = {
  SET_STATE: 'COMPONENTS_SET_STATE'
}

export {
  COMPONENTS_DOMAIN,
  COMPONENTS_STATE,
  COMPONENTS_ACTION
}
